import gql from "graphql-tag";
const getCalcQuery = gql(` 
query GetCalc($params: AWSJSON!) {
  getCalc(params: $params) {
    id
    result
  }
}
`)
export default getCalcQuery;
